<div class="background-color integration-item u-padding-16">
  <div class="integration-item__apis">
    <span class="integration-item__title line-height-24 u-font-size-16">
      API access to test data
    </span>
    <div class="integration-item__api-info border-color background-color-intense u-margin-top-20 u-margin-bottom-8">
      <form class="o-flex o-flex--column" [formGroup]="apisForm">
        <div *ngFor="let key of formKeys(); index as i;">
          <mat-slide-toggle
            class="integration-item__api"
            [formControlName]="key"
          >{{getNameFromKey(key)}}</mat-slide-toggle>
          <div class="integration-item__apilink line-height-16 u-font-size-14">
            <a href="{{getHelpDeskFromKey(key)}}" target="_blank">Helpdesk</a>
          </div>
        </div>
      </form>
    </div>
    <div>
      Setting up these integrations with external aggregator platforms such as AZUM will require the API key shown at the top of this page
    </div>
    <button mat-raised-button color="primary" class="integration-item__float-right" (click)="save()">Save</button>
  </div>
</div>
